module.exports = __webpack_public_path__ + "static/shifting-gears-to-drive-f8da8c2afd1458f27fa7040761f772a1.jpg";